<template>
<div>
    <v-autocomplete ref="autoTeam" v-model="listSelected" :items="listItem" :autofocus="initFields.autofocus" :class="(initFields.class) ? initFields.class : 'rounded-lg'"
        @input="autoImput" :search-input="search" @update:search-input="onSearchInput" @change="handleChange"
        :item-text="textToshow" :item-value="initFields.index" :label="title" 
        :style="(initFields.zindex) ? 'z-index:' + initFields.zindex + ';' : ''" 
        :multiple="multiSelect" :prepend-icon="preprendIcon" chips small-chips clearable :hide-selected="initFields.hideSelected"
        :auto-select-first= "initFields.autoselectfirst" :disabled="isDisabled" :background-color="this.initFields['background-color']"
        :outlined="initFields.outlined" :dense="initFields.dense" :rounded="initFields.rounded" :deletable-chips="initFields.deletablechips"
        :error-messages="errorMessages">
        <template v-if="fields.itemTemplate" v-slot:item="data">
            <slot name="item" v-bind="data">
                <v-list-item-content>
                    <v-list-item-title>{{ textToshow(data.item) }}</v-list-item-title>
                </v-list-item-content>
            </slot>
        </template>
        <template v-slot:no-data>
            <div v-if="notfoundClick && (search && search.length > 0)" @click="notfoundClick(search)" tabindex="0" aria-selected="false" role="option" class="v-list-item v-list-item--link theme--light">
                <div class="v-list-item__content">
                    <div class="v-list-item__title">
                        <span class="v-list-item__mask"><v-icon>mdi-pen-plus</v-icon> {{initFields.notfound}} : {{ search }}</span>
                    </div>
                </div>
            </div>
            <span v-else class="ma-2">{{initFields.notfound}}</span>
        </template>
    </v-autocomplete>
</div>
</template>

<script>

export default {
    name: 'autocomplete_ressource',
    props: {
        ressource: String,
        listParent: Array,
        fields: Object,
        title: String,
        listObject: [Array, Object, Number],
        disabled: Boolean,
        notfoundClick: Function,
        errorMessages: [Array, String],
        searchTransform: {
            type: Function,
            default: null
        }
    }, 
    data: function () {
        return {
            loading     : { getVersion: false, getRessource: false },
            ischange    : false,
            search      : null,
            listSelected: null,
            listItem    : [],
            saveRessource : false,
            modalRessource: false,
            multiSelect   : true,
            preprendIcon  : 'mdi-account',
            params        : '',
            initFields    : {}
        }
    },
    computed: {
        isDisabled () {
            return this.disabled || false
        }
    },
    watch: {
        search (val) {
            if(this.initFields.resultlimit === 'false'){
                return
            }
            if( this.loading.getRessource ){
                clearTimeout(this.loading.getRessource)
            }
            if( this.ressource && val && val.length > 1 ){
                var searchTab = this.fields.search.split(',')
                var search = ''
                searchTab.forEach( (elem) => {
                    search += '&' + elem.trim() + '=%' + val + '%'
                })
                search = '&' + searchTab[0].trim() + '=%' + val + '%' //Todoo multi -> delete this line
                this.loading.getRessource = setTimeout( () => {
                    this.getRessource(search)

                }, 800)
            } else if(this.fields.prefetch && val == '') {
                this.getRessource('')
            } else {
                return false
            }
        },
        listObject() {
            this.listSelected = this.listObject
        }
    },
    beforeMount: function(){
        this.initFields = Object.assign({}, this.fields)

        this.initFields.outlined           = this.fields.outlined !== undefined ? this.fields.outlined : true
        this.initFields.itemTemplate       = this.fields.itemTemplate || false
        this.initFields.dense              = this.fields.dense || false
        this.initFields.filled             = this.fields.filled || false
        this.initFields.flat               = this.fields.flat || false
        this.initFields['full-width']      = this.fields['full-width'] || false
        this.initFields.reverse            = this.fields.reverse || false
        this.initFields.rounded            = this.fields.rounded || false
        this.initFields['background-color']= this.fields['background-color'] || undefined
        this.initFields.deletablechips     = this.fields.deletablechips || false
        this.initFields.hideSelected       = this.fields.hideSelected !== undefined ? this.fields.hideSelected : true
        

        this.initFields.autofocus       = this.fields.autofocus || false
        this.initFields.autoselectfirst = this.fields.autoselectfirst || false
        this.initFields.params          = this.fields.params || ''
        this.initFields.notfound        = this.fields.notfound || 'Aucun élément de trouvé'
        this.initFields.prefetch        = this.fields.prefetch || false
        this.initFields.resultlimit     = this.fields.resultlimit || 25
        this.params                 = ( this.fields.params.length > 0 ) ? '&' + this.fields.params : '';
    },
    mounted:function (){
        this.multiSelect  = (this.fields.multiSelect == undefined) ? true : this.fields.multiSelect
        this.preprendIcon = (this.fields.preprendIcon == undefined) ? undefined : this.fields.preprendIcon
        this.outlined     = (this.fields.outlined === true) ? true : false
        this.dense        = (this.fields.dense === true) ? true : false
        if( this.multiSelect && this.listObject !== undefined && this.listObject.length > 0 ){
            this.listSelected = this.listObject
        } else if( !this.multiSelect && this.listObject !== undefined ){
            this.listSelected = this.listObject
        }
        if( this.fields.prefetch ){
            this.getRessource('').then( () => {
                this.listItem = this.mergeArrayObject(this.listItem, this.listParent, this.fields.index)
            })
        } else {
            this.listItem     = this.listParent
        }
    },
    methods: {
        async onSearchInput(value) {
            if (this.searchTransform && typeof this.searchTransform === 'function') {
                const result = this.searchTransform(value)
                // Si la fonction retourne une Promise, on l'attend
                this.search = result instanceof Promise ? await result : result
            } else {
                this.search = value
            }
        },
        getRessource(search){
            return new Promise( (resolve, reject) => {
                if(this.ressource){
                    this.$http.get( '/' + this.ressource + '/?per_page=' + this.initFields.resultlimit + this.params + encodeURI(search) ).then( (response) => {
                        this.listItem = this.listParent.concat(response.data.data)
                        resolve('resolved')
                    }).catch( (error) => { 
                        reject(error)
                    })
                } else {
                    resolve('resolved')
                }

            })
        },
        autoImput(){
            var listObject = []
            this.listItem.forEach(element => {
                if( this.listSelected && this.listSelected !== undefined && this.listSelected.isArray ){
                    if( this.listSelected.indexOf( element[ this.fields.index ] ) > -1 ){
                        listObject.push( element ) //this.listParent.push( element )
                    }
                } else {
                    listObject.push( element )
                }
            })
            this.$emit('update:listParent', listObject)
            this.$emit('update:listObject', this.listSelected)
            this.$emit('change', this.listSelected)
            // Réinitialiser le champ de recherche après sélection
            this.search = ''
        },
        handleChange(selectedValues) {
            if (this.multiSelect) {
                const values = selectedValues || []
                const selectedObjects = this.listItem.filter(item => 
                    values.includes(item[this.fields.index])
                )
                this.$emit('change', selectedObjects)
            } else {
                const selectedObject = this.listItem.find(item => 
                    item[this.fields.index] === selectedValues
                ) || null
                this.$emit('change', selectedObject)
            }
        },
        switchModal(name, mode){
            name    = name || 'modalressource'
            mode    = mode || 0
            //refresh = refresh || false
            this[name] = mode
        },
        textToshow(item) {
            if (!this.fields.text || !item) return ''
            
            return this.fields.text.split(',').map(field => {
                if (field.includes('.')) {
                    // Handle nested property like equ_customfields.equ_id_carrier
                    const parts = field.split('.')
                    let value = item
                    for (const part of parts) {
                        if (value) {
                            value = value[part]
                        }
                    }
                    return value || ''
                }
                return item[field] || ''
            }).join(' - ')
        },
        mergeArrayObject(a, b, prop) {
            let reduced = a.filter(aitem => !b.find(bitem => aitem[prop] === bitem[prop]))
            return reduced.concat(b)
        },
        async refreshList(id) {
            this.loading.getRessource = true
            this.search = ''
            this.listItem = []
            await this.getRessource('')
            this.listSelected = id
            this.loading.getRessource = false
        }
    },
    components: {

    }
}
</script>